import type { FieldDescriptor } from '@/types/fieldDescriptor';

/** Full proposer schema fields (includes optional PAN for Aadhaar-or-PAN validation). */
export const PROPOSER_FIELDS: FieldDescriptor[] = [
  {
    id: 'name',
    fieldType: 'TEXT',
    label: 'Proposer Name',
    placeholder: 'Enter proposer name',
    validation: {
      required: true,
      minLength: 1,
      errorMessage: 'Proposer name is required',
      pattern: '^[a-zA-Z\\s.]+$',
      patternMessage: 'Name cannot contain special characters',
    },
    transform: {
      toStore: (raw) => raw.replace(/[^a-zA-Z\s.]/g, ''),
    },
  },
  {
    id: 'gender',
    fieldType: 'DROPDOWN',
    label: 'Gender',
    options: [
      { value: 'MALE', label: 'Male' },
      { value: 'FEMALE', label: 'Female' },
    ],
    validation: { required: true, errorMessage: 'Proposer gender is required' },
  },
  {
    id: 'aadharNumber',
    fieldType: 'TEXT',
    label: 'Aadhar Number',
    placeholder: 'Enter Aadhar number',
    validation: {
      required: true,
      pattern: '^\\d{12}$',
      patternMessage: 'Aadhaar number must contain exactly 12 digits',
    },
    inputProps: {
      inputMode: 'numeric',
      maxLength: 12,
      autoComplete: 'off',
      spellCheck: false,
      autoCorrect: 'off',
      autoCapitalize: 'off',
    },
  },
  {
    id: 'phoneNumber',
    fieldType: 'PHONE',
    label: 'Phone number',
    placeholder: 'Enter Phone number',
    validation: {
      required: true,
      pattern: '^[6-9]\\d{9}$',
      patternMessage: 'Please enter a valid 10-digit mobile number',
      minLength: 10,
      maxLength: 10,
    },
  },
  {
    id: 'dateOfBirth',
    fieldType: 'DATE',
    label: 'Date of Birth',
    placeholder: 'Date of Birth',
    validation: {
      required: true,
      errorMessage: 'Proposer date of birth is required',
    },
  },
  {
    id: 'email',
    fieldType: 'EMAIL',
    label: 'Email Address',
    placeholder: 'Enter email address',
    validation: {
      required: true,
      errorMessage: 'Please enter a valid email address',
    },
    inputProps: {
      autoCapitalize: 'off',
      autoCorrect: 'off',
      spellCheck: false,
    },
  },
  {
    id: 'panNumber',
    fieldType: 'TEXT',
    label: 'PAN number',
    placeholder: 'Enter PAN number',
    validation: {},
    inputProps: {
      maxLength: 10,
      autoComplete: 'off',
      spellCheck: false,
      autoCorrect: 'off',
      autoCapitalize: 'off',
    },
    transform: { toStore: (raw) => raw.toUpperCase() },
    hidden: () => true,
  },
];

/** Fields rendered on verify-details (excludes hidden PAN). */
export const VERIFY_DETAILS_PROPOSER_FIELDS = PROPOSER_FIELDS.filter(
  (field) => field.id !== 'panNumber',
);
